import { FieldError } from './ValidationError';
import i18Next from 'i18next';

/** Format field/input errors that come from BE so they can be easily used with Formik's setErrors function */
const formatBackendValidationErrors = (fieldErrors: FieldError[] = []) => {
  const errors: { [index: string]: string } = {};
  fieldErrors.forEach((fieldError) => {
    errors[fieldError.property] = i18Next.t(
      `error:validation.${fieldError.messageTemplate}`,
    );
  });
  return errors;
};

export default formatBackendValidationErrors;
